// extracted by mini-css-extract-plugin
export default {"container":"styles_container__slCb7","title":"styles_title__niEnN","content":"styles_content__MVN76","policyWrapper":"styles_policyWrapper__OpMSw"};